import { render, staticRenderFns } from "./OnboardingSuccess.vue?vue&type=template&id=c6bb1766&scoped=true"
import script from "./OnboardingSuccess.vue?vue&type=script&lang=ts"
export * from "./OnboardingSuccess.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingSuccess.vue?vue&type=style&index=0&id=c6bb1766&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bb1766",
  null
  
)

export default component.exports